/**
 * Step3「What we'll do」展示逻辑 — 与 Plan Gate / 原 DiagnosisUnlock 一致。
 *
 * - **非会员**：`hideActionSummarySection: false` → 展示 + blur
 * - **会员**：`hideActionSummarySection: true` → 不展示（Figma 会员态省略）
 */
export function shouldShowBlurredActionSummary(options: {
  hideActionSummarySection: boolean;
  actionSummary?: string;
}): boolean {
  const { hideActionSummarySection, actionSummary } = options;
  return Boolean(actionSummary && !hideActionSummarySection);
}
